<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-card-title class="toolbar"> Group Album </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="6">
            <v-select
              :items="communication_groups"
              prepend-icon="mdi-account-child-circle"
              item-text="title"
              item-value="id"
              @change="getNotices(selected_group)"
              outlined
              dense
              hint="Select Group"
           persistent-hint
              v-model="selected_group"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <br />
    <div v-for="notice in searchByTitleOrDescription" :key="notice.id">
      <v-card dense>
        <v-chip class="ma-2" :color="notice.srno % 2 == 0 ? 'warning' : 'info'">
          {{ notice.issue_date }}
        </v-chip>
        <v-card-title class="title font-weight-regular">
          {{ notice.title }}
        </v-card-title>
        <v-card-title class="body-2 font-weight-regular">
          <v-btn
            class="ma-2"
            small
            outlined
            color="indigo"
            v-if="!notice.visited"
            @click="viewMoreAlbum(notice)"
            >View More</v-btn
          >
          <span v-if="notice.visited == true"
            >Description:{{ notice.description }}
          </span>
        </v-card-title>

        <v-card-actions>
          <!-- <v-card-subtitle v-if="notice.attachment" class="font-regular">
            Downloadable Attachment
            <v-btn
              class="mx-2"
              small
              dark
              outlined             
              color="success"
              @click="downloadNoticeAttachment(notice.attachment_links)"
              >{{ notice.attachment }}<v-icon> mdi-download</v-icon>
            </v-btn>

          </v-card-subtitle> -->
          <v-card-subtitle v-if="notice.attachment" class="font-regular">
            Downloadable Attachment
            <span v-for="(item, i) in notice.attachment_links" :key="i">
              <a
                class="p-2"
                :href="basepath + item.path + item.name"
                target="blank"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-if="notice.attachment != null"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="black">mdi-download</v-icon></v-btn
                    >
                  </template>
                  <span> View Attachment File!!! </span>
                </v-tooltip>
              </a>
            </span>
          </v-card-subtitle>

          <!-- <v-spacer> </v-spacer><v-card-subtitle> from @{{ notice.from }}</v-card-subtitle> -->
        </v-card-actions>
      </v-card>
      <br />
    </div>

    <!--{{ child_notice }}-->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    selected_group: "",
    communication_groups: [],
    child_info: null,
    children: [],
    selected_children: "",
    child_notice: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    loader: true,
    search: "",
    s3url: "",
    basepath: "",
  }),

  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getNotices(item) {
      const formData = {
        group_id: item,
        type: "Album",
      };
      axios
        .post("communicationGroup/getNoticess", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if ((res.data.status = "SUCCESS")) {
              if (res.data.child_info.length != 0) {
                this.child_info = res.data.child_info;
                this.childrenList();
              } else {
              }
            }
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    onLoad() {
      const formData = {
        type: "Album",
      };
      axios
        .get("communicationGroup/getCalendar")
        .then((res) => {
          if (res.data.msg == "200") {
            this.communication_groups = res.data.communication_groups;
            return;
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.loader = false;
          //alert("done")
        });
    },
    viewMoreAlbum(notice) {
      const formData = {
        id: notice.notice_id,
        commn_to_grp_id: notice.commn_to_grp_id,
        type: "Album",
      };
      axios
        .post("/communicationGroup/markViewedNotice", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            if (res.data.status == "SUCCESS") {
              notice.visited = true;
            } else {
              //alert(res.data.status_reason);
            }
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.loader = false;
          //alert("done")
        });
    },
    downloadNoticeAttachment(dlinkpath) {
      //console.log("dlinkpath>>"+dlinkpath)
      for (let j = 0; j < dlinkpath.length; j++) {
        var link = document.createElement("a");
        let path = dlinkpath[j].path;
        link.download = dlinkpath[j].name; // 16yqok7xkop.xls
        //console.log("url>>"+s3url+path+link.download)
        link.href = this.s3url + path + link.download;
        link.target = "_blank";
        link.click();
      }
    },
    childrenList() {
      //console.log(" children Len>>"+this.child_info.length)
      for (let i = 0; i < this.child_info.length; i++) {
        //console.log(" children>>"+this.child_info[i].grno)
        this.children.push(
          this.child_info[i].grno + ":" + this.child_info[i].name
        );
        this.selected_children =
          this.child_info[i].grno + ":" + this.child_info[i].name;
        this.displayAlbum();
      }
      //console.log(" children>>"+this.children)
    },
    displayAlbum() {
      //alert('11'+this.selected_children)
      // let grno = this.selected_children;
      // let res = grno.split(":");
      // // return res[1];
      // for (let i = 0; i < this.child_info.length; i++) {
      //   if (res[0] == this.child_info[i].grno)
      //     this.child_notice = this.child_info[i];
      // }
      for (let i = 0; i < this.child_info.length; i++) {
        //if (res[0] == this.child_info[i])
        this.child_notice = this.child_info[i];
      }
      if (this.child_notice.notices.length == 0) {
        this.showSnackbar("#b71c1c", "No Events Available For This Group..!!!");
        return;
      }
    },
  },
  mounted() {
    this.onLoad();
    this.s3url = localStorage.getItem("awspath");
    this.basepath = localStorage.getItem("awspath");
  },
  computed: {
    searchByTitleOrDescription() {
      /*function compare(a, b) {
        if (a.title < b.title || a.description < b.description) return -1;
        if (a.title > b.title || a.description < b.description) return 1;
        return 0;
      }
      if (!this.search) return this.child_notice.notices.sort(compare);*/
      if (this.child_notice) {
        return this.child_notice.notices.filter((tbdata) => {
          return (
            tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            tbdata.description
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
          );
        });
      }
    },
  }, // end of computed()
};
</script>
